<div class="container-fluid" style="padding: 0; overflow: hidden">
  <div class="row">
    <div
      class="col-md-12 d-flex"
      alt="Immagine di login"
      id="background-image"
    ></div>
    <div class="col-md-12 d-flex login_style justify-content-center">
      <div class="col-md-6">
        <form [formGroup]="formLogin">
          <div class="center-container mt-0" style="border-radius: 0.5rem">
            <div style="background-color: white">
              <div
                class="col-md-12 d-flex flex-column align-items-start px-4 mt-4"
              >
                <div style="width: 15rem; height: auto">
                  <img src="../../assets/images/Logo-OG.png" />
                </div>
                <div
                  class="mt-4 justify-content-center align_style d-flex justify-content-center"
                >
                  <div style="width: 75%; text-align: center">
                    <img src="../../assets/images/LOGO_FIGURINO.png" />
                  </div>
                </div>
                <div class="mt-3 align_style">
                  <a
                    style="color: #199c72; font-weight: 600; font-size: 1.25rem"
                    >{{ "InsertPersonalCredential" | translate }}</a
                  >
                </div>
                <div
                  class="mt-4 d-flex flex-column justify-content-start"
                  style="
                    width: 100%;
                    padding-left: 5rem;
                    padding-right: 5rem;
                    height: 7rem;
                  "
                >
                  <div style="font-weight: 400; font-size: 1.3125rem">
                    {{ "Username" | translate }}
                  </div>
                  <div class="col-md-12 d-flex flex-wrap">
                    <input
                      class="input_style w-100 col-md-12 form-control"
                      type="text"
                      id="username"
                      name="username"
                      formControlName="username"
                      placeholder="{{ 'Username' | translate }}"
                      [ngClass]="{
                        'is-valid':
                          isOnSubmit && formLogin.get('username').valid,
                        'is-invalid':
                          isOnSubmit && formLogin.get('username').invalid
                      }"
                      autocomplete="off"
                    />
                    <span
                      class="text-danger"
                      *ngIf="
                        formLogin.get('username').invalid &&
                        isOnSubmit &&
                        formLogin.get('username').value == ''
                      "
                    >
                      Inserire username.
                    </span>
                  </div>
                </div>
                <div
                  class="mt-4 d-flex flex-column justify-content-start col-md-12"
                  style="width: 100%; padding-left: 5rem; padding-right: 5rem"
                >
                  <div style="font-weight: 400; font-size: 1.3125rem">
                    {{ "Password" | translate }}
                  </div>
                  <div
                    class="col-md-12 d-flex flex-wrap justify-content-end position-relative"
                  >
                    <input
                      class="input_style col-md-11 form-control pe-5"
                      type="password"
                      id="password"
                      name="password"
                      formControlName="password"
                      placeholder="{{ 'Password' | translate }}"
                      [ngClass]="{
                        'is-valid':
                          isOnSubmit && formLogin.get('password').valid,
                        'is-invalid':
                          isOnSubmit && formLogin.get('password').invalid
                      }"
                      autocomplete="off"
                    />
                    <span
                      *ngIf="!formLogin.get('password').invalid"
                      class="icon-password-toggle position-absolute me-3 d-grid align-content-center justify-content-center"
                      style="height: 3rem; width: 1.8rem"
                      (click)="togglePasswordVisibility()"
                    >
                      <i
                        class="fa"
                        style="font-size: larger; color: var(--blue-dils)"
                        [ngClass]="{
                          'fa-eye': !hidePassword,
                          'fa-eye-slash': hidePassword
                        }"
                      ></i>
                    </span>
                    <div class="col-md-12 d-flex justify-content-end">
                      <span
                        class="text-danger col-md-6"
                        *ngIf="
                          formLogin.get('password').invalid &&
                          isOnSubmit &&
                          formLogin.get('password').value == ''
                        "
                      >
                        Inserire password.
                      </span>
                      <div class="col-md-6 d-flex justify-content-end">
                        <a
                          [routerLink]="['/login/forgot-password']"
                          style="color: var(--blue-dils)"
                        >
                          {{ "ForgotPassword" | translate }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mt-4 d-flex justify-content-start align-items-center"
                  style="padding-left: 5.3rem"
                >
                  <input
                    type="checkbox"
                    class="form-check-input me-2"
                    id="rememberme"
                    name="rememberme"
                    value="valoreScelto"
                    formControlName="remember"
                    (change)="onChangeRemember($event)"
                  />
                  <label style="color: var(--blue-dils)" for="rememberme">
                    {{ "RememberMe" | translate }}
                  </label>
                </div>
                <div
                  class="mt-5 d-flex justify-content-center"
                  style="padding-left: 5rem; padding-right: 5rem; width: 100%"
                >
                  <button
                    class="btn btn_login"
                    (click)="onSubmit()"
                    [disabled]="isDisabled"
                  >
                    {{ "SignIn" | translate }}
                  </button>
                </div>
                <!-- <div
                  class="mt-3 d-flex justify-content-center"
                  style="padding-left: 5rem; padding-right: 5rem; width: 100%"
                >
                  <button
                    class="btn btn_login_sso d-flex align-items-center justify-content-center"
                    type="button"
                    (click)="onSubmitSSO()"
                  >
                    <label
                      style="color: var(--blue-dils); cursor: pointer"
                      class="me-3"
                      >MICROSOFT</label
                    >
                    <img
                      class="p-2"
                      style="height: inherit; width: auto; cursor: pointer"
                      src="../../../assets/images/microsoft_icon.png"
                    />
                  </button>
                </div> -->
                <div
                  class="mt-3 d-flex justify-content-center"
                  style="padding-left: 5rem; padding-right: 5rem; width: 100%"
                >
                  <button
                    class="btn btn_login_sso d-flex align-items-center justify-content-center"
                    type="button"
                    (click)="onSubmitOktaSSO()"
                  >
                    <label
                      style="color: var(--blue-dils); cursor: pointer"
                      class="me-3"
                      >LOGIN WITH SSO</label
                    >
                    <img
                      class="p-2"
                      style="height: inherit; width: auto; cursor: pointer"
                      src="../../../assets/images/okta_icon.svg"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
